import 'css-chunksrc/client/pages/exportsPage/wbsReport/filters/dataTypeFilter/styles.scss';export default {
  "dataTypeFilter": "_dataTypeFilter_1mbbp_1",
  "input": "_input_1mbbp_7",
  "toggleArrow": "_toggleArrow_1mbbp_23",
  "selectedDataTypes": "_selectedDataTypes_1mbbp_31",
  "placeholder": "_placeholder_1mbbp_40",
  "list": "_list_1mbbp_45",
  "item": "_item_1mbbp_57",
  "typeName": "_typeName_1mbbp_70",
  "opened": "_opened_1mbbp_77"
};